import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {
    FileAttachment,
    FileAttachmentsV1Service,
    ProductAmount,
    ProductAmountsV1Service
} from "../../../apis/backend";
import {firstValueFrom, mergeMap} from "rxjs";
import {
    ProductAmountDialogComponent,
} from "../dialog/product-amount-dialog.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileAttachmentComponent} from "../../../components/file-attachments/file-attachment/file-attachment.component";

@Component({
    selector: 'product-amount',
    templateUrl: './product-amount-detail.component.html',
})
export class ProductAmountDetailComponent implements OnInit {
    
    public ProductAmount: ProductAmount;
    
    public EditMode = false;
    
    constructor(private _fileAttachmentService: FileAttachmentsV1Service,
                private _productAmountService: ProductAmountsV1Service,
                private _modalService: NgbModal,
                private _route: ActivatedRoute) {}
    
    ngOnInit() {
        this._route.params.pipe(
            mergeMap(params => {
                return this._productAmountService.getProductAmount(params['productAmountID']);
            })
        )
            .subscribe(productAmount => {
                this.ProductAmount = productAmount;
            });
    }

    public EditProductAmount() {
        if (this.ProductAmount) {
            let productAmount = <ProductAmount>JSON.parse(JSON.stringify(this.ProductAmount));

            let modal = this._modalService.open(ProductAmountDialogComponent, { size: 'lg' });
            modal.componentInstance.ProductAmount = productAmount;

            modal.result
                .then((productAmount: ProductAmount) => {
                    return firstValueFrom(this._productAmountService.updateProductAmount(productAmount.ProductAmountID, productAmount));
                })
                .then((productAmount: ProductAmount) => {
                    this.ProductAmount = productAmount;
                });
        }
    }
}